import clx from 'classnames';
import React from 'react';
import { Form, IFormProps } from '../Form';
import { ContentBlock } from '../ui/ContentBlock';

export interface IWidgetPreviewFormProps extends Omit<IFormProps, 'onSubmit'> {
  children: React.ReactNode;
}

/**
 * Versione semplificata di FormHandler che non permette il submit ma mantiene
 * le stesse proprietà a livello di UI. Utilizzato per la preview dei widget.
 */
export function WidgetPreviewForm(props: IWidgetPreviewFormProps) {
  const { children, ...formProps } = props;

  return (
    <Form
      layout="vertical"
      onSubmit={() => {}}
      {...formProps}
      className={clx('form-handler', formProps.className)}
    >
      <>
        {children}
        <ContentBlock />
      </>
    </Form>
  );
}
